

    if (window.Sentry) {
      window.Sentry.init({ dsn: "https://2062d0a4929b45348643784b5cb39c36@sentry.wixpress.com/1643", environment: 'Editor' });
    }
  

    import React from 'react';
    import ReactDOM from 'react-dom';
    import { withStyles } from '@wix/native-components-infra';
    import EditorAppWrapper from '@wix/yoshi-flow-editor/runtime/esm/EditorAppWrapper.js';
    import Widget from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post/Widget/index.tsx';
    import createController from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post/controller.ts';

    
import { createHttpClient } from '@wix/yoshi-flow-editor/runtime/esm/controller/httpClientProp';
    

    

  import { initI18nWithoutICU as initI18n } from '@wix/yoshi-flow-editor/runtime/esm/i18next/init';


    
const multilingualDisabled = false;

    
import { createExperiments, createWidgetExperiments } from '@wix/yoshi-flow-editor/runtime/esm/experiments';
    

    
import { createRavenClient } from '@wix/yoshi-flow-editor/error-monitor';
    import Raven from '@wix/yoshi-flow-editor/raven-js';
    var createErrorMonitor = function(options) {
      return createRavenClient({
        Raven,
        ...options,
      });
    };
    

    
import { I18nextProvider } from '@wix/yoshi-flow-editor/i18n';


      import { PureExperimentsProvider } from '@wix/yoshi-flow-editor';
      var ExperimentsProvider = React.Fragment;
      

import { BILoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/BILogger/BILoggerProvider';

import { PanoramaProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/PanoramaProvider';

import { FedopsLoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/FedopsLoggerProvider';

import { HttpProvider } from '@wix/yoshi-flow-editor';

import { TPAComponentsProvider } from 'wix-ui-tpa';

import { BaseUiEnvironmentProviderWrapper } from '@wix/yoshi-flow-editor/runtime/esm/react/BaseUiEnvironmentProviderWrapper';

var providers = {
  I18nextProvider,
  ExperimentsProvider,
  PureExperimentsProvider,
  BILoggerProvider,
  FedopsLoggerProvider,
  PanoramaProvider,
  HttpProvider,
  TPAComponentsProvider,
  BaseUiEnvironmentProviderWrapper,
}

    import * as fedopsLogger from '@wix/yoshi-flow-editor/fedops';

    
  import * as viewerApp from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/viewer.app.ts';
    var importedApp = viewerApp;

    var componentName = 'Post';
    var projectName = 'communities-blog-ooi';
    var sentryConfig = {
      DSN: 'https://2062d0a4929b45348643784b5cb39c36@sentry.wixpress.com/1643',
      id: '2062d0a4929b45348643784b5cb39c36',
      projectName: 'communities-blog-ooi',
      teamName: 'blogas',
      errorMonitor: true,
    };
    

    import * as usersStyleParamsEntry from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/Post/stylesParams.ts';
var stylesParamsEntry = usersStyleParamsEntry;
var stylesParams = stylesParamsEntry.default;
var customCssVars = stylesParamsEntry.customCssVars || function() { return {} };
    


    var experimentsConfig = {"centralized":true,"scopes":["wix-social-blog","ricos"]};
    var fedopsConfig = null;
    var translationsConfig = {"enabled":true,"icuEnabled":false,"defaultTranslationsPath":"/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/assets/locales/messages_en.json","availableLanguages":["ar","bg","ca","cs","da","de","el","en","es","fi","fr","he","hi","hu","id","it","ja","ko","lt","ms","nl","no","pl","pt","ro","ru","sk","sl","sv","th","tl","tr","uk","vi","zh"]};
    var defaultTranslations = {"app-manifest.page-info":"Page Info","app-manifest.layout":"Layout","app-manifest.layouts":"Layout","app-manifest.design":"Design","app-manifest.permissions":"Permissions","app-manifest.seo":"SEO Basics","app-manifest.blog-pages":"Blog Pages","app-manifest.manage-posts":"Manage Posts","app-manifest.delete-page":"Delete","app-manifest.delete-blog":"Delete Blog","app-manifest.settings":"Settings","app-manifest.widget-settings":"Widget settings","app-manifest.post-page-label":"Post","app-manifest.post-list":"Post List","app-manifest.post-ticker":"Post Ticker","app-manifest.category-list":"Categories","app-manifest.archive-list":"Archive","app-manifest.app-descriptor.post-settings-title":"Post","app-manifest.app-descriptor.create-post":"Create Post","app-manifest.app-descriptor.manage-posts":"Manage Blog","app-manifest.app-descriptor.manage-blog-pages":"Manage Blog Pages","app-manifest.app-descriptor.open-page-settings":"Customize Post Page","app-manifest.app-descriptor.add-blog-elements":"Add Blog Elements","app-manifest.app-descriptor.read-blogging-guide":"Read the Blogging Guide","member-pages.origin":"By Wix Blog","member-pages.posts.name":"Blog Posts","member-pages.posts.short-description":"Display members’ posts in one place","member-pages.posts.description.text":"Members can write and display their own blog posts to any visitors on the site.","member-pages.posts.description.bullet-point-1":"See all published posts","member-pages.posts.description.bullet-point-2":"Create a new post","member-pages.posts.description.bullet-point-3":"Scan for likes and comments on posts","member-pages.posts.description.bullet-point-4":"Keep track of the most popular posts","member-pages.drafts.name":"My Drafts","member-pages.drafts.short-description":"Let members create and manage their own blog drafts","member-pages.drafts.description.text":"On this private page, members can freely:","member-pages.drafts.description.bullet-point-1":"Create and edit drafts","member-pages.drafts.description.bullet-point-2":"Save drafts and come back to them later","member-pages.drafts.description.bullet-point-3":"Delete rejected drafts","member-pages.comments.name":"Blog Comments","member-pages.comments.short-description":"Display members' comments in one place","member-pages.comments.description.text":"Members can see comments they’ve made on the blog.","member-pages.comments.description.bullet-point-1":"Scan comments easily","member-pages.comments.description.bullet-point-2":"Engage in the discussion","member-pages.comments.description.bullet-point-3":"Discover the most popular comments and topics","member-pages.likes.name":"Blog Likes","member-pages.likes.short-description":"Display members' likes in one place","member-pages.likes.description.text":"Members can see all the posts they’ve liked on the blog.","member-pages.likes.description.bullet-point-1":"Scan likes easily","member-pages.likes.description.bullet-point-2":"Keep track of most liked posts","member-pages.followers.name":"Followers","member-pages.followers.short-description":"Let your members view and follow one another","member-pages.followers.description.text":"Allow members to see who’s following who in your community.","member-pages.followers.description.bullet-point-1":"View a list of your followers","member-pages.followers.description.bullet-point-2":"Follow or unfollow members from your list","member-pages.followers.description.bullet-point-3":"See who’s following other members of the community","member-pages.followers.description.bullet-point-4":"Manage members, set roles, assign badges, and more","member-pages.about.name":"Profile","member-pages.about.short-description":"Give your members their own personal profile","member-pages.about.description.text":"Members can customize their own profile that’ll express who they are to your online community.","member-pages.about.description.bullet-point-1":"Write something about yourself","member-pages.about.description.bullet-point-2":"Add images and video","member-pages.about.description.bullet-point-3":"View your community stats","member-pages.about.description.bullet-point-4":"View and assign badges","member-pages.about.description.bullet-point-5":"Share your profile","member-pages.about.origin":"By Wix Members","member-pages.followers.origin":"By Wix Members","installation-timeout.title":"Try installing Blog again","installation-timeout.description":"There was a technical issue with the app installation. Installing again shouldn’t take long.","installation-timeout.mainAction":"Try Again","installation-timeout.secondaryAction":"Delete App","post-page.displayName":"Post Page"};
    var styleHocConfig = {"enabled":true};
    var biConfig = null;
    var appDefinitionId = "14bcded7-0066-7c35-14d7-466cb3f09103";
    var componentId = "211b5287-14e2-4690-bb71-525908938c81";
    var localeDistPath = 'assets/locales';
    var persistentAcrossPages = false;
    var shouldUseEssentials = true;
    var shouldSkipMultipleRendersAfterViewModeChange = true;
    var withErrorBoundary = false;

    import { createVisitorBILogger as biLogger } from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/target/generated/bi/createBILogger.ts';
    
      import { hot } from '@wix/component-hot-loader';
      var UserComponent = hot(module, Widget);
    

    var EditorComponent = React.createElement(EditorAppWrapper, {
      UserComponent,
      appDefinitionId,
      componentId,
      name: componentName,
      sentryConfig: sentryConfig,
      styleHocConfig: styleHocConfig,
      experimentsConfig: experimentsConfig,
      fedopsConfig: fedopsConfig,
      multilingualDisabled,
      translationsConfig: translationsConfig,
      defaultTranslations: defaultTranslations,
      shouldUseEssentials,
      persistentAcrossPages,
      projectName: projectName,
      biConfig: biConfig,
      biLogger: biLogger,
      stylesParams,
      customCssVars,
      withErrorBoundary,
      shouldSkipMultipleRendersAfterViewModeChange,
      userController: createController,
      customInitAppForPage: importedApp.initAppForPage,
      optionalDeps: {
        initI18n,
        fedopsLogger,
        withStylesHoc: withStyles,
        createHttpClient,
        createExperiments,
        createWidgetExperiments,
        createErrorMonitor,
        providers,
      },
      localeDistPath: localeDistPath,
    });
    ReactDOM.render(EditorComponent, document.getElementById('root'));
